<template>
  <div class="big-shot-wrap">
    <moduleTitle title1="大咖助阵" title2="EXPERT" id="big-shot" />
    <div class="big-shot-list" id="big-shot1">
      <div class="big-shot" v-for="list in bigShots" :key="list.name">
        <div class="content-wrap" :class="list.words ? 'have-wrods-wrap' : ''">
          <img class="head-img" :src="list.img" alt="" />
          <div class="profile">
            <div
              class="title"
              v-for="(item, index) in list.titles"
              :key="index"
            >
              {{ item }}
            </div>
            <div class="post" v-if="list.post">{{ list.post }}</div>
            <div class="name">{{ list.name }}</div>
          </div>
          <div class="words">
            <div>
              {{ list.words }}
            </div>
          </div>
        </div>
      </div>
      <img
        class="mysterious-bigshot"
        src="~@/assets/financialCompetition/mysterious_bigshot.png"
      />
    </div>
  </div>
</template>
<script>
import moduleTitle from './moduleTitle'
export default {
  name: 'BigShot',
  components: { moduleTitle },
  data() {
    return {
      bigShots: window.financialCompetitionResource.bigShots
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
#big-shot,
#big-shot1 {
  opacity: 0;
}
.big-shot-wrap {
  width: 1200px;
  padding: 64px 0 48px;
  margin: 0 auto;
}
.big-shot-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  margin-top: 40px;
  justify-content: center;
}
.big-shot {
  width: 325px;
  min-width: 325px;
  height: 429px;
  margin: 0 13px 19px 0;
  border-radius: 25px;
  overflow: hidden;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  &:nth-of-type(3n + 3) {
    margin-right: 0;
  }
  &:hover {
    background-image: linear-gradient(to bottom, #0ff4f1, #3060ff);
    box-shadow: 0px 7px 40px 0px rgba(194, 194, 194, 1);
  }
  .content-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 25px;
    overflow: hidden;
  }
  .have-wrods-wrap {
    &:hover {
      background-color: #fff;
      .profile {
        display: none;
      }
      .words {
        display: flex;
        width: 100%;
      }
    }
  }
  .head-img {
    width: 327px;
    height: 429px;
    position: absolute;
    top: 0;
    left: 0;
  }
  .profile {
    position: absolute;
    bottom: 0;
    padding: 0 21px 20px;
    height: 199px;
    width: 100%;
    background-image: linear-gradient(
      0deg,
      rgba(10, 10, 10, 0.69) 0%,
      rgba(38, 38, 38, 0) 90%
    );
    display: flex;
    flex-direction: column-reverse;
    .name {
      height: 34px;
      font-family: PingFangSC-Medium;
      font-size: 20px;
      line-height: 34px;
      font-weight: 500;
    }
    .post {
      height: 14px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      line-height: 14px;
      margin: 3px 0 12px;
    }
    .title {
      height: 22px;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      line-height: 22px;
    }
  }
  .words {
    position: absolute;
    bottom: 0;
    display: none;
    height: 199px;
    background-image: linear-gradient(
      0deg,
      #46b0f2 0%,
      rgba(30, 106, 250, 0.42) 56%,
      rgba(0, 55, 255, 0) 90%
    );
    display: none;
    align-items: flex-end;
    padding: 0 21px 31px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #fff;
    line-height: 22px;
  }
}
.mysterious-bigshot {
  width: 325px;
  height: 429px;
  border-radius: 25px;
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/bigShot.vue